import { BaseContainerService } from './base-container-service';
import { BaseEntity } from './../../../base-models/base-entity';
import { Injectable } from "@angular/core";
import { Subject, Observable } from 'rxjs';
import { ModelData } from '../../../base-models/model-data';

@Injectable({
    providedIn: 'root'
})
export class InlineContainerService<T extends BaseEntity> extends BaseContainerService<T> {
    constructor(){
        super();
    }

    private activeComponentSubject: Subject<string> = new Subject<string>();
    ActiveComponent: Observable<string> = this.activeComponentSubject.asObservable();
    private itemDeletedSubject: Subject<boolean> = new Subject<boolean>();
    ItemDeleted: Observable<boolean> = this.itemDeletedSubject.asObservable();

    AddItem(){
        this.ShowUpdate();
        this.SelectItem(-1);
    }

    EditItem(modelData: ModelData, ID: number){
        this.ShowUpdate();
        this.SelectItem(ID);
    }
    // EditItem(modelData: ModelData, ID: number, Useridlk: number){
    //     this.ShowUpdate();
    //     this.SelectItem(ID);
    //     this.SelectUseridlk(Useridlk);
    // }

    ShowList(){
        this.selectComponent('list');
    }

    ShowUpdate(){
        this.selectComponent('update');
    }

    private selectComponent(componentName: string){
        this.activeComponentSubject.next(componentName);
    }

    OnItemDeleted(){
        this.itemDeletedSubject.next(true);
    }
}